<template>
  <div class="comments-list">
    <comment v-for="comment in comments" v-bind:key="comment.id" :hashid="comment.id" v-bind="comment.attributes" :cloudapp-links="comment.links.cloudapp_links">
    </comment>
  </div>
</template>

<script>
import Comment from './comment.vue';

export default {
  components: { Comment },
  props: {
    limit: {
      type: Number,
      default: 100,
    },
  },
  computed: {
    comments: function() {
      return this.$store.state.comments.slice(0, this.limit);
    }
  },
  watch: {
    comments: function(newVal, oldVal) {
      if(newVal.length > oldVal.length){
        this.$nextTick(() =>  window.scrollTo(0,document.body.scrollHeight));
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../packs/application.scss';

</style>
